import {
  getLISAOrderLinkFromSlide,
  getLisaSlideLink,
} from 'components/utilities/getLinks';
import Box from '@mui/material/Box';
import { Grid } from '@mui/material';
import React from 'react';
import { AttributeLabel } from 'components/Modals/QCPassFailModal/AttributeLabel';
import { AttributeLink } from 'components/Modals/QCPassFailModal/AttributeLink';

export const QCSlideInfoFields = ({ slide }) => {
  let organName;
  let speciesName;
  let controlType;
  let fixationTime;
  let fixativeName = '';

  const stainName = slide.stain ? slide.stain : '';
  const { level, number, stain_type, thumbnail_ocr_text } = slide;

  const { sample } = slide;
  const sampleName = sample ? sample.name : '';
  if (sample) {
    organName = sample.organ ? sample.organ.name : '';
    speciesName = sample.species ? sample.species.name : '';
    controlType = sample.control_type ? sample.control_type : '';
    fixationTime = sample.fixation_time_hours ? sample.fixation_time_hours : '';
  }

  if (slide.order.fixative) {
    fixativeName = slide.order.fixative.name;
  }

  const lisaSlideLink = getLisaSlideLink({ slide });
  const lisaOrderLink = getLISAOrderLinkFromSlide({ slide });

  return (
    <Box mb={2}>
      <Grid container spacing={1} justifyContent="space-around">
        <Grid item xs={5}>
          <Box>
            <img
              src={slide.medium_macro_url}
              height={'auto'}
              width={'50%'}
              alt={'Macro Slide'}
            />
          </Box>
        </Grid>
        <Grid item xs={7}>
          <AttributeLabel label={'Order Name'} value={slide.order.name} />
          <AttributeLabel label={'Sample Name'} value={sampleName} />
          <AttributeLabel label={'Stain Name'} value={stainName} />
          <AttributeLabel label={'Stain Type'} value={stain_type} />
          <AttributeLabel label={'Organ'} value={organName} />
          <AttributeLabel label={'Species'} value={speciesName} />
          <AttributeLabel label={'Level'} value={level} />
          <AttributeLabel label={'Number'} value={number} />
          <AttributeLabel label={'Control Type'} value={controlType} />
          <AttributeLabel
            label={'Fixation Time (Hours)'}
            value={fixationTime}
          />
          <AttributeLabel label={'Fixative'} value={fixativeName} />
          <AttributeLink label={'LIS'} value={'Slide'} link={lisaSlideLink} />
          <AttributeLink label={'LIS'} value={'Order'} link={lisaOrderLink} />
          <AttributeLabel label={'OCR Text'} value={thumbnail_ocr_text} />
        </Grid>
      </Grid>
    </Box>
  );
};
